import {
  actionToUci,
  chess,
  fromPgn,
  toPgn,
  type ChessState,
} from "../chess";
import { ChessRenderer } from "./chess-renderer";
import type {
  GameDefinition,
} from "./types";

export const chessDefinition: GameDefinition<ChessState> = {
  gameId: "chess",
  gameName: "Chess",
  variantId: "standard",
  variantName: "Standard 8×8",
  board: { width: 8, height: 8 },
  observationShape: [8, 8, 119],
  actionCount: 4_672,
  defaultSimulations: 32,
  defaultHumanPlayer: 1,
  modelIds: [
    "helpful-bush-570-v6",
    "desert-snowball-1028-v42",
    "desert-snowball-1028-v85",
    "quiet-river-72-v63",
  ],
  playerNames: ["White", "Black"],
  controls: { pgn: true },
  createEnvironment: () => chess,
  createRenderer: () => new ChessRenderer(),
  createInferenceInput: (state) => ({
    observation: chess.observe(state),
    legalActionMask: chess.legalActionMask(state),
  }),
  statusText: (state) => {
    if (!state.terminalReason) {
      return `${state.color === 0 ? "White" : "Black"} to move`;
    }
    const labels: Record<NonNullable<ChessState["terminalReason"]>, string> = {
      checkmate: `Checkmate · ${state.color === 0 ? "Black" : "White"} wins`,
      stalemate: "Draw · stalemate",
      "insufficient-material": "Draw · insufficient material",
      "fifty-move": "Draw · 50-move rule",
      "threefold-repetition": "Draw · threefold repetition",
      "max-steps": "Draw · maximum steps",
      "illegal-action": "Game over · illegal action",
    };
    return labels[state.terminalReason];
  },
  moveHistory: (state) => state.moves.map((move) => move.uci),
  serializeGame: (states) => toPgn(states),
  loadGame: (pgn) => fromPgn(pgn).states,
};

export function formatChessAction(state: ChessState, action: number): string {
  return actionToUci(action, state.color);
}
